var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.748 11C13.3003 11 13.748 11.4477 13.748 12V17C13.748 17.5523 13.3003 18 12.748 18C12.1958 18 11.748 17.5523 11.748 17V12C11.748 11.4477 12.1958 11 12.748 11Z",
    fill: "#0062E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.748 9C13.3003 9 13.748 8.55228 13.748 8C13.748 7.44772 13.3003 7 12.748 7C12.1958 7 11.748 7.44772 11.748 8C11.748 8.55228 12.1958 9 12.748 9Z",
    fill: "#0062E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74805 12C2.74805 6.47715 7.2252 2 12.748 2C18.2709 2 22.748 6.47715 22.748 12C22.748 17.5228 18.2709 22 12.748 22C7.2252 22 2.74805 17.5228 2.74805 12ZM12.748 3C7.77748 3 3.74805 7.02944 3.74805 12C3.74805 16.9706 7.77748 21 12.748 21C17.7186 21 21.748 16.9706 21.748 12C21.748 7.02944 17.7186 3 12.748 3Z",
    fill: "#0062E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.2e9d621cd93172b1ef2877dd8baef8da.svg";
export { ForwardRef as ReactComponent };